import { Box } from "@shared/primitive-components"
import { Logo } from "../Branding"
import * as styles from "./styles/barLogoStyles"

interface Props {
  homeButtonHandler?: React.MouseEventHandler<HTMLButtonElement>
}

const BarLogo = ({ homeButtonHandler }: Props) => (
  <Box css={styles.root(!!homeButtonHandler)} onClick={homeButtonHandler}>
    <Logo variant="brand" width="148px" />
  </Box>
)

BarLogo.defaultProps = {
  homeButtonHandler: undefined,
}

export default BarLogo
